import { applyMove, cloneState } from "../cube/model.js";

export class SolutionTimeline {
  constructor(N, startState, moves, { checkpointEvery = 12 } = {}) {
    this.N = N;
    this.length = moves.length;
    this.moves = Object.freeze(
      moves.map((move) =>
        Object.freeze({ ...move, layers: Object.freeze([...move.layers]) }),
      ),
    );
    this.checkpointEvery = Math.max(1, checkpointEvery);
    this.checkpoints = new Map([[0, cloneState(startState)]]);

    const state = cloneState(startState);
    for (let index = 0; index < this.moves.length; index++) {
      applyMove(state, N, this.moves[index]);
      const cursor = index + 1;
      if (cursor % this.checkpointEvery === 0 || cursor === this.moves.length) {
        this.checkpoints.set(cursor, cloneState(state));
      }
    }
  }

  stateAt(rawCursor) {
    const cursor = Math.max(0, Math.min(this.length, Math.trunc(rawCursor)));
    let checkpoint = cursor - (cursor % this.checkpointEvery);
    while (!this.checkpoints.has(checkpoint) && checkpoint > 0) checkpoint--;
    const state = cloneState(this.checkpoints.get(checkpoint));
    for (let index = checkpoint; index < cursor; index++)
      applyMove(state, this.N, this.moves[index]);
    return state;
  }
}
